var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "BadgeCampaignList",
      "extra-items": ['徽章管理']
    }
  })], 1)]), _c('b-card', [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading,
      "rounded": "sm"
    }
  }, [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-2 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v("徽章管理")]), _c('div', {
    staticClass: "\n            col-12 col-xl-8\n            d-flex\n            flex-column flex-xl-row\n            align-items-start align-items-xl-center\n          "
  }, [_vm.checkPermission([_vm.consts.BADGE_CREATE]) && _vm.badgeCampaignId ? _c('b-button', {
    staticClass: "flex-shrink-0 mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary",
      "to": {
        name: 'BadgeCreateByBadgeCampaign'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("新增徽章 ")]) : _vm._e(), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.merchants.length == 2
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.merchantId,
      callback: function callback($$v) {
        _vm.merchantId = $$v;
      },
      expression: "merchantId"
    }
  }), _c('b-form-select', {
    attrs: {
      "options": _vm.badgeCampaigns,
      "disabled": _vm.badgeCampaigns.length == 2
    },
    on: {
      "change": _vm.handlePageResetWithoutReload
    },
    model: {
      value: _vm.badgeCampaignId,
      callback: function callback($$v) {
        _vm.badgeCampaignId = $$v;
      },
      expression: "badgeCampaignId"
    }
  }), _c('b-input-group', {
    staticClass: "ml-0 ml-xl-4"
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋徽章名稱"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handlePageResetWithoutReload.apply(null, arguments);
      }
    },
    model: {
      value: _vm.query.keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "keyword", $$v);
      },
      expression: "query.keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": _vm.handlePageResetWithoutReload
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1)], 1)]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.badges,
      "fields": _vm.fields
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "cell(image_url)",
      fn: function fn(data) {
        return [data.item.image_url ? _c('b-img-lazy', {
          staticClass: "thumb-image",
          attrs: {
            "src": data.item.image_url,
            "alt": "徽章圖片",
            "width": "50",
            "height": "50"
          }
        }) : _vm._e()];
      }
    }, {
      key: "cell(started_at_and_end_at)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(_vm.formatDate(data.item.available_start_at)) + " ")]), _c('div', [_vm._v(_vm._s(_vm.formatDate(data.item.available_end_at)))])];
      }
    }, {
      key: "cell(branch)",
      fn: function fn(data) {
        return [_c('div', {
          staticClass: "mb-1"
        }, [_vm._v(" " + _vm._s(data.item.branch ? data.item.branch.name : "") + " ")]), _c('div', [_vm._v(" " + _vm._s(data.item.branch ? data.item.branch.branch_code : "") + " ")])];
      }
    }, {
      key: "cell(arrange)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.BADGE_LIST_VIEW]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: _vm.merchantId && _vm.badgeCampaignId ? 'BadgeViewByBadgeCampaign' : 'BadgeDetail',
              params: {
                badgeId: data.item.id,
                merchantId: _vm.merchantId,
                badgeCampaignId: _vm.badgeCampaignId
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-eye"
        }), _vm._v(" 查看 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.BADGE_EDIT]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: _vm.merchantId && _vm.badgeCampaignId ? 'BadgeEditByBadgeCampaign' : 'BadgeEdit',
              params: {
                badgeId: data.item.id,
                merchantId: _vm.merchantId,
                badgeCampaignId: _vm.badgeCampaignId
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil"
        }), _vm._v(" 編輯 ")]) : _vm._e(), _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteBadge(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")]), _vm.checkPermission([_vm.consts.BADGE_EDIT]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-primary",
            "to": {
              name: _vm.merchantId && _vm.badgeCampaignId ? 'BadgeCustomerListByCampaign' : 'BadgeCustomerList',
              params: {
                badgeId: data.item.id,
                merchantId: _vm.merchantId,
                badgeCampaignId: _vm.badgeCampaignId
              }
            }
          }
        }, [_vm._v("會員列表 ")]) : _vm._e()];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }